import { render, staticRenderFns } from "./fontSelector.vue?vue&type=template&id=84ec3160&"
import script from "./fontSelector.vue?vue&type=script&lang=ts&"
export * from "./fontSelector.vue?vue&type=script&lang=ts&"
import style0 from "./fontSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports